// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"EnterForm_formGroup__2XzH7"};